module.exports = __webpack_public_path__ + "img/1_016.6d832f2c.jpg";